"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("@fluentui/react");
var index_1 = require("./index");
require("./MinutePicker.scss");
var EnumUnit;
(function (EnumUnit) {
    EnumUnit[EnumUnit["minutes"] = 0] = "minutes";
    EnumUnit[EnumUnit["hours"] = 1] = "hours";
})(EnumUnit || (EnumUnit = {}));
exports.MinutePicker = function (props) {
    var value = props.value, onChange = props.onChange, maxValue = props.maxValue, labels = props.labels, readOnly = props.readOnly;
    var _a = react_1.useState(value && value >= 60 && value % 60 === 0 ? EnumUnit.hours : EnumUnit.minutes), unit = _a[0], setUnit = _a[1];
    var onValueChange = function (currentUnit, val) {
        var newVal = val;
        if (newVal) {
            if (newVal < 0) {
                newVal = 0;
            }
            if (maxValue) {
                var maxVal = maxValue;
                if (currentUnit === EnumUnit.hours && maxValue % 60 !== 0) {
                    maxVal = Math.trunc(maxValue / 60) * 60;
                }
                if (newVal > maxVal) {
                    newVal = maxVal;
                }
            }
        }
        onChange(newVal);
        return (newVal);
    };
    var applyUnit = function (valUnit, val) {
        if (val !== undefined && val >= 0) {
            switch (valUnit) {
                case EnumUnit.hours:
                    return (Math.round((val / 60)).toString());
                case EnumUnit.minutes:
                    return (val.toString());
                default:
                    break;
            }
        }
        return ('');
    };
    var asMinute = function (valUnit, val) {
        if (val) {
            switch (valUnit) {
                case EnumUnit.hours:
                    return Number.parseInt(val, 10) * 60;
                case EnumUnit.minutes:
                    return Number.parseInt(val, 10);
                default:
                    break;
            }
        }
        return (undefined);
    };
    var updateVal = function (val, inc) {
        if (val === '') {
            return '0';
        }
        return (Number.parseInt(val, 10) + inc).toString();
    };
    var unitOptions = [{ key: EnumUnit.minutes, text: labels.minutes },
        { key: EnumUnit.hours, text: labels.hours }];
    return (react_1.default.createElement("div", { className: 'eta-minutePicker' },
        react_1.default.createElement(react_2.SpinButton, { className: 'numberPicker', disabled: readOnly, min: 0, max: maxValue, step: 1, value: applyUnit(unit, value), onValidate: function (val) {
                return applyUnit(unit, onValueChange(unit, asMinute(unit, val)));
            }, onIncrement: function (val) {
                var newVal = updateVal(val, 1);
                return applyUnit(unit, onValueChange(unit, asMinute(unit, newVal)));
            }, onDecrement: function (val) {
                var newVal = updateVal(val, -1);
                return applyUnit(unit, onValueChange(unit, asMinute(unit, newVal)));
            } }),
        react_1.default.createElement(index_1.Dropdown, { readOnly: readOnly, selectedKey: unit, onChange: function (ev, option) {
                setUnit(option ? option.key : EnumUnit.minutes);
                if (value && (option === null || option === void 0 ? void 0 : option.key) === EnumUnit.hours) {
                    onValueChange(option === null || option === void 0 ? void 0 : option.key, Math.round(value / 60) * 60); // remove the rest of unit switch to hours.
                }
            }, options: unitOptions })));
};
//# sourceMappingURL=MinutePicker.js.map